import gql from 'graphql-tag'

/**
 * Query
 */
const GET_WITH_PAGINATION = gql`
query advanceControlWithPagination($page: Int, $perPage: Int, $filters: FiltersAdvanceControl) {
  advanceControlWithPagination(page: $page, first: $perPage, filters: $filters){
    paginatorInfo {
      currentPage
      count
      hasMorePages
      perPage
      total
    }
    data {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      advance_type_id
      advanceType {
        id
        name
      }
      register_date
      discount_date
      amount
      observations
    }
  }
}
`

const GET_ALL = gql`
  query advanceControls ($filters: FiltersAdvanceControl) {
    advanceControls (filters: $filters) {
      id
      employee_id
      employee {
        id
        name
        last_name
        document_type
        document_number
        mothers_last_name
        fullName
        email
      }
      advance_type_id
      advanceType {
        id
        name
      }
      register_date
      discount_date
      amount
      observations
    }
  }
`

/**
 * Mutations
 */
const CREATE = gql`
  mutation createAdvanceControl ($input: AdvanceControlForm!) {
    createAdvanceControl (input: $input) {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        fullName
        email
      }
      advance_type_id
      advanceType {
        id
        name
      }
      register_date
      discount_date
      amount
      observations
    }
  }
`

const UPDATE = gql`
  mutation updateAdvanceControl ($id: ID!, $input: AdvanceControlForm!) {
    updateAdvanceControl (id: $id, input: $input) {
      id
      employee_id
      employee {
        id
        name
        last_name
        mothers_last_name
        fullName
        email
      }
      advance_type_id
      advanceType {
        id
        name
      }
      register_date
      discount_date
      amount
      observations
    }
  }
`

const DELETE = gql`
  mutation deleteAdvanceControl ($id: ID!) {
    deleteAdvanceControl(id: $id) { 
      id
    }
  }
`

const VALIDATE_EXISTS_ADVANCE_CONTROL = gql`
  mutation validateAdvanceControl($id: ID, $input: AdvanceControlForm!) {
    validateAdvanceControl (id: $id, input: $input) {
      success
      msgError
    }
  }
`

export {
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL,
  VALIDATE_EXISTS_ADVANCE_CONTROL
}
